import React from "react";
import PropTypes from "prop-types";
import CheckBox from "../Form/Checkbox/Checkbox";
import CollapseList from "./CollapseList/CollapseList";
import "./content-tree.scss";

const ContentTree = ({ content, handleChange, selected }) => {
  return (
    <ul className="content-tree">
      {content.map((item, idx) => {
        if (!item.list) {
          return (
            <li key={`${item.label}-${idx}`}>
              <CheckBox
                id={item.id}
                value={JSON.stringify(item)}
                checked={selected.includes(JSON.stringify(item))}
                onChange={handleChange}
                text={item.label}
              />
            </li>
          );
        }
        return (
          <CollapseList
            key={`${item.label}-${idx}`}
            content={item}
            handleChange={handleChange}
            selected={selected}
            idx={idx}
          />
        );
      })}
    </ul>
  );
};

ContentTree.propTypes = {
  content: PropTypes.instanceOf(Object),
  handleChange: PropTypes.func,
  selected: PropTypes.instanceOf(Array),
};

export default ContentTree;
